// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1oJaJ","author":"Table_author__2DcmD","authorImage":"Table_authorImage__1lUbZ","unreadRow":"Table_unreadRow__Ju-pR"};